import React from "react";
import {
  Breadcrumb,
  DetailsList,
  DetailsListLayoutMode,
  DetailsRow,
  Fabric,
  IColumn,
  IDetailsListProps,
  IDetailsRowStyles,
  PrimaryButton,
  SelectionMode,
  Stack,
  TooltipHost,
} from "@fluentui/react";
import { mdiPencilOutline, mdiTrashCanOutline } from "@mdi/js";
import { useHistory, useParams } from "react-router-dom";
import { THEME } from "../../../utils/Styles";
import { IAssignedEscalationMatrix, IPreviousMeeting } from "../../../vm";
import {
  ASSIGNED_ESCALATION_MATRIX_TYPE_DICT,
  childrenGap,
  childrenGap8,
  EMATRIX_DIC,
  EMATRIX_LEVELS_DICT,
} from "../../common/Constants";
import NoDataTile from "../../common/NoDataTile";
import Icon from "@mdi/react";
import {
  getAllCustomers,
  getAssignedEscalationMatrix,
} from "../../../services/customers/CustomerService";
import { ToastContext } from "../../common/ToastProvider";
import { ConfirmDialogContext } from "../../common/ConfirmDialogProvider";
import { Loading } from "../../../services/Loading";
import ManageAEmDialog from "./ManageAEmDialog";
import { parseJwt } from "../../../services/UtilService";

export interface AssignEscalationMatrixProps { }

const AssignEscalationMatrix: React.FC<AssignEscalationMatrixProps> = () => {
  // custom hooks
  const history = useHistory();
  const params: any = useParams();
  const { showToast } = React.useContext(ToastContext);
  const { showConfirmDialog } = React.useContext(ConfirmDialogContext);
  const tokenData = parseJwt();

  // state
  const [state, setState] = React.useState({
    isLoading: false,
    assignedEm: [],
    searchObj: {
      customerId: params.customerId,
    },
    manageEmDialog: {
      isOpen: false,
      index: undefined,
      data: undefined,
    },
  } as {
    isLoading: boolean;
    assignedEm: IAssignedEscalationMatrix[];
    searchObj: {
      customerId: string;
    };
    manageEmDialog: {
      isOpen: boolean;
      index?: number;
      data?: IAssignedEscalationMatrix;
    };
  });

  const [customer, setCustomer] = React.useState({
    isLoading: false,
    customer: {
      name: "",
    },
  } as {
    isLoading: boolean;
    customer: any;
  });

  React.useEffect(() => {
    const asyncFunc = async () => {
      await getAllAssignedEm();
      await getACustomer();
    };
    asyncFunc();
  }, []);

  const getACustomer = async () => {
    setCustomer({ ...customer, isLoading: true });
    let result = await getAllCustomers({ customerId: params.customerId });
    if (result?.success) {
      setCustomer({
        ...customer,
        customer: result.data[0],
        isLoading: false,
      });
    } else {
      setCustomer({ ...customer, isLoading: false });
    }
  };

  const getAllAssignedEm = async (stateObj?: any) => {
    let localState = { ...state };
    if (stateObj) localState = { ...localState, ...stateObj };

    setState({ ...localState, isLoading: true });

    let result = await getAssignedEscalationMatrix(localState.searchObj);
    if (result?.success) {
      setState({
        ...localState,
        assignedEm: result.data,
        isLoading: false,
      });
    } else {
      setState({ ...localState, isLoading: false });
      showToast(
        result?.message || "Error while getting assigned escalation matrix",
        "error"
      );
    }
  };

  const handleDialogOpen = (isOpen: boolean, index?: number) => {
    let assignedEm = undefined;
    if (index !== undefined) {
      assignedEm = { ...state.assignedEm[index] };
    }
    setState({
      ...state,
      manageEmDialog: {
        isOpen,
        index,
        data: assignedEm,
      },
    });
  };

  const handleDialogClose = async (data: IAssignedEscalationMatrix) => {
    // let assignedEm = [...state.assignedEm];
    if (data) {
      let stateObj = {
        ...state,
        manageEmDialog: {
          isOpen: false,
          index: undefined,
          data: undefined,
        }
      }
      await getAllAssignedEm(stateObj);
      //   if (state.manageEmDialog.index !== undefined) {
      //     assignedEm[state.manageEmDialog.index] = data;
      //     showToast("Assigned successfully", "success");
      //   } else {
      //     assignedEm.unshift(data);
      //     showToast("Assigned  successfully", "success");
      //   }
    } else {
      setState({
        ...state,
        manageEmDialog: {
          isOpen: false,
          index: undefined,
          data: undefined,
        },
        // assignedEm,
      });
    }
  };

  const _renderItemColumn = (item: any, index: number, column: IColumn) => {
    switch (column.key) {
      case "actions":
        return (
          <Stack horizontal>
            <TooltipHost
              content={`Edit`}
              id={`editEm`}
              calloutProps={{ gapSpace: 0 }}
              styles={{ root: { display: "inline-block" } }}
            >
              <span onClick={() => handleDialogOpen(true, index)}>
                <Icon
                  path={mdiPencilOutline}
                  size={0.8}
                  className="pointer"
                  color={THEME.palette.themePrimary}
                />
              </span>
            </TooltipHost>
            {/* &nbsp;&nbsp; */}
            {/* <TooltipHost
              content={`Delete Previous Meeting`}
              id={`deleteEm`}
              calloutProps={{ gapSpace: 0 }}
              styles={{ root: { display: "inline-block" } }}
            >
              <span onClick={() => deleteSd(item, index)}>
                <Icon
                  path={mdiTrashCanOutline}
                  size={0.8}
                  className="pointer"
                  color={THEME.palette.themePrimary}
                />
              </span>
            </TooltipHost> */}
          </Stack>
        );
      case "type": {
        return (
          <span style={{ fontWeight: 600 }}>
            {ASSIGNED_ESCALATION_MATRIX_TYPE_DICT[item.type]}
          </span>
        );
      }
      case "aEM": {
        return (
          <Stack horizontal wrap tokens={childrenGap8}>
            {item.escalationMatrixes.map((ele: any, index: number) => (
              <Stack.Item key={index} className="chips">
                <span>{ele?.name + ` (${EMATRIX_DIC[ele?.type] || 'N/A'} - ${EMATRIX_LEVELS_DICT[ele?.level] || 'N/A'})` || ""}</span>
              </Stack.Item>
            ))}
          </Stack>
        );
      }
      default:
        return <span>{column.fieldName ? item[column.fieldName] : ""}</span>;
    }
  };

  const _onRenderRow: IDetailsListProps["onRenderRow"] = (props) => {
    const customStyles: Partial<IDetailsRowStyles> = {};
    if (props) {
      if (props.itemIndex % 2 !== 0) {
        customStyles.root = { backgroundColor: "#F3F3F3" };
      }

      return <DetailsRow {...props} styles={customStyles} />;
    }
    return null;
  };

  const handleLoading = () => {
    setState({
      ...state,
      isLoading: !state.isLoading,
    });
  };

  return (
    <React.Fragment>
      {(state.isLoading || customer.isLoading) && <Loading />}
      <Stack tokens={childrenGap}>
        <Stack.Item>
          <Breadcrumb
            items={[
              {
                text: customer.customer.name,
                key: "name",
                onClick: () => {
                  history.push(`/customers/${customer.customer._id}`);
                },
              },
              {
                text: "Assigned Escalation Matrix",
                key: "assigned-escalation-matrix",
                isCurrentItem: true,
              },
            ]}
          />
        </Stack.Item>
        <Stack.Item>
          <Stack horizontal wrap tokens={childrenGap} horizontalAlign="end">
            {![4].includes(tokenData.role) && (
              // {![2, 4].includes(tokenData.role) && (
              <Stack.Item>
                <PrimaryButton
                  text="Assign Escalation Matrix"
                  onClick={() => handleDialogOpen(true)}
                  className="borderless-btn bg-white"
                />
              </Stack.Item>
            )}
          </Stack>
        </Stack.Item>
        <Stack.Item>
          {state.assignedEm && state.assignedEm.length > 0 ? (
            <Fabric>
              <DetailsList
                items={state.assignedEm}
                columns={![4].includes(tokenData.role) ? [
                  // columns={![2, 4].includes(tokenData.role) ? [
                  {
                    key: "type",
                    name: "Function",
                    // name: "Type",
                    fieldName: "type",
                    minWidth: 200,
                    maxWidth: 300,
                    isResizable: true,
                  },
                  {
                    key: "aEM",
                    name: "Assigned Escalation Matrix",
                    fieldName: "aEM",
                    minWidth: 500,
                    maxWidth: 800,
                    isResizable: true,
                  },
                  {
                    key: "actions",
                    name: "Actions",
                    fieldName: "actions",
                    minWidth: 150,
                    maxWidth: 200,
                    isResizable: true,
                  },
                ] : [
                  {
                    key: "type",
                    name: "Type",
                    fieldName: "type",
                    minWidth: 200,
                    maxWidth: 300,
                    isResizable: true,
                  },
                  {
                    key: "aEM",
                    name: "Assigned Escalation Matrix",
                    fieldName: "aEM",
                    minWidth: 500,
                    maxWidth: 800,
                    isResizable: true,
                  },
                ]}
                compact={true}
                setKey="set"
                onRenderItemColumn={_renderItemColumn as any}
                layoutMode={DetailsListLayoutMode.justified}
                selectionMode={SelectionMode.none}
                onRenderRow={_onRenderRow}
              />
            </Fabric>
          ) : (
            <NoDataTile title="No Assigned Escalation Matrix Found for this Customer"></NoDataTile>
          )}
        </Stack.Item>
      </Stack>
      {state.manageEmDialog.isOpen && (
        <ManageAEmDialog
          data={state.manageEmDialog.data}
          handleLoading={handleLoading}
          handleDialogClose={(data: IAssignedEscalationMatrix) =>
            handleDialogClose(data)
          }
          customerId={params.customerId}
          allEscalationMatrix={state.assignedEm}
        />
      )}
    </React.Fragment>
  );
};

export default AssignEscalationMatrix;
